export const IS_EXIST_DIGIT = / *[0-9]/;
export const IS_EXIST_UPPERCASE = /[A-Z]/;
export const IS_EXIST_LOWERCASE = /[a-z]/;
export const IS_VALID_PHONE = /[A-Za-z0-9]+$/;
export const IS_ONLY_TEXT = /^[a-zA-Z ]*$/;
export const IS_ONLY_DIGITS = /^[0-9]+$/;
export const IS_VALID_EMAIL = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
